"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const calculateActiveDestructibles_1 = __importDefault(require("./calculateActiveDestructibles"));
const getTilemap_1 = __importDefault(require("./definables/getTilemap"));
const gameIsOngoing_1 = __importDefault(require("./gameIsOngoing"));
const isClawOnCooldown_1 = __importDefault(require("./isClawOnCooldown"));
const getAudioSource_1 = __importDefault(require("./definables/getAudioSource"));
const state_1 = __importDefault(require("../state"));
const isCootsInObstacle_1 = __importDefault(require("./isCootsInObstacle"));
const levelIsCompleted_1 = __importDefault(require("./levelIsCompleted"));
const attemptScratch = () => {
    if ((0, gameIsOngoing_1.default)() && (0, isCootsInObstacle_1.default)() === false && (0, levelIsCompleted_1.default)() === false && state_1.default.isInBed === false) {
        const cooldown = (0, isClawOnCooldown_1.default)();
        if (cooldown === false) {
            const clawedAt = state_1.default.currentTime;
            const destructible = (0, getTilemap_1.default)(state_1.default.level.tilemapSlug).getDestructibleWithinRange();
            const willDestroy = destructible !== null;
            if (!willDestroy) {
                state_1.default.recentDestruction = {
                    clawedAt,
                    destructibleID: null,
                    tileID: null
                };
                (0, getAudioSource_1.default)("noises/scratch").play(null, null);
            }
            else {
                state_1.default.recentDestruction = {
                    clawedAt,
                    destructibleID: destructible.destructibleID,
                    tileID: destructible.tileID
                };
                (0, getAudioSource_1.default)("noises/scratch").play(null, () => {
                    if (destructible.audioSourceSlug) {
                        (0, getAudioSource_1.default)(destructible.audioSourceSlug).play(null, null);
                    }
                });
                const brokenDestructibleIDs = state_1.default.brokenDestructibleIDs;
                state_1.default.brokenDestructibleIDs = [...brokenDestructibleIDs, destructible.destructibleID];
                state_1.default.activeDestructibleIDs = state_1.default.activeDestructibleIDs.filter((activeDestructible) => activeDestructible !== destructible.destructibleID);
                if ((0, levelIsCompleted_1.default)()) {
                    state_1.default.levelCompletedAt = state_1.default.currentTime;
                }
                (0, calculateActiveDestructibles_1.default)();
            }
        }
    }
};
exports.default = attemptScratch;
